module.exports = __webpack_public_path__ + "static/media/picture-(198).13169dbb.JPG";